import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useRoute } from 'vue-router'

import { UserQueryEnum, type UserType } from '@models/entities/users'

import { queryController } from '@composables/queryController'

export const useUserQueryStore = defineStore('useUserQueryStore', () => {
  const route = useRoute()
  const { getQueryString } = queryController()

  const getInitialState = () => ({
    [UserQueryEnum.show_user_info]: getQueryString(route.query, UserQueryEnum.show_user_info),
    [UserQueryEnum.user_id]: getQueryString(route.query, UserQueryEnum.user_id)
  })

  const userDetailsState = ref(getInitialState())

  const setUserDetailsQuery = (user?: UserType | null) => {
    userDetailsState.value[UserQueryEnum.show_user_info] = user ? '1' : ''
    userDetailsState.value[UserQueryEnum.user_id] = user ? String(user.id) : ''
  }

  const clearUserDetailsState = () => {
    userDetailsState.value = {
      [UserQueryEnum.show_user_info]: '',
      [UserQueryEnum.user_id]: ''
    }
  }

  return {
    userDetailsState,
    setUserDetailsQuery,
    clearUserDetailsState
  }
})
